/**
 * DopaPractice Typography Engine (Clinical Polish)
 * ─────────────────────────────────────────────────────────────────────────────
 * Lấy cảm hứng từ sự tỉ mỉ của nghệ thuật sắp chữ thủ công:
 * 1. Khóa từ ghép Y khoa & Thuật ngữ lâm sàng (tránh bị ngắt đôi xuống dòng).
 * 2. Khóa Số + Đơn vị đo lường/tiền tệ (32 mmHg, 18 cm, 19 °C, 1.889.000 ₫).
 * 3. Chống rớt từ mồ côi (Widow Words) ở cuối đoạn văn và tiêu đề.
 * 
 * An toàn 100% với React DOM và Shopify Liquid (dùng TreeWalker tác động thuần túy lên Text Nodes).
 */
(function () {
  'use strict';

  const NB = '\u00A0'; // Non-breaking space

  // Bộ từ điển từ ghép Y khoa, Lâm sàng & Thương hiệu Dopa
  // Sắp xếp tự động theo độ dài giảm dần để ưu tiên khớp cụm từ dài trước
  const MEDICAL_COMPOUND_WORDS = [
    'bác sĩ', 'lâm sàng', 'phẫu thuật', 'ngoại khoa', 'nội khoa', 'sản phụ khoa',
    'tai mũi họng', 'da liễu', 'nhi khoa', 'chẩn đoán', 'điều trị', 'bệnh nhân',
    'người bệnh', 'phòng mổ', 'phòng khám', 'bệnh viện', 'ca trực', 'hội chẩn',
    'thủ thuật', 'cấp cứu', 'vô khuẩn', 'kháng khuẩn', 'kháng thẩm thấu', 'nano shield',
    'chống thấm', 'kháng tĩnh điện', 'sợi carbon', 'vi sợi carbon', 'ống nghe',
    'vớ y khoa', 'vớ nén', 'công thái học', 'thao tác', 'chỉ đường', 'lịch khám',
    'đặt hẹn', 'chuyên môn', 'xác thực', 'chứng chỉ hành nghề', 'tối giản', 'chuẩn mực',
    'phục trang', 'tươm tất', 'đĩnh đạc', 'phẳng phiu', 'nếp nhăn', 'đầm nặng',
    'ép nhiệt', 'gãy gọn', 'suốt ca', 'giọt bắn', 'dịch tiết', 'trượt đi',
    'bám dính', 'thể lực', 'tuần hoàn', 'hồi lưu', 'trọng lực', 'kháng cự',
    'DopaPractice', 'DopeCoat', 'DopeScrub', 'DopeScrubs', 'DopeCredit', 'Empower Coat', 'Steadfast Coat', 'Littmann'
  ].sort((a, b) => b.length - a.length);

  const RX_WORDS = MEDICAL_COMPOUND_WORDS.map(w =>
    new RegExp('(^|[^\\p{L}])(' + w.replace(/\s+/g, '\\s+') + ')(?![\\p{L}])', 'giu')
  );

  // Selector áp dụng: Tiêu đề, thẻ mô tả, danh sách, nút bấm
  const TARGET_SELECTOR = 'h1, h2, h3, h4, h5, h6, p, li, dt, dd, .dcs-tagline, .dpb-subtext, .dcs-desc, .dryd-desc, .bento-desc, .dopa-ui-btn';

  function polishElement(el) {
    if (!el || el.dataset.dopaNbProcessed) return;
    if (el.closest('nav, script, style, pre, code, [data-no-typography]')) return;
    el.dataset.dopaNbProcessed = '1';

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const textNodes = [];
    let n;
    while ((n = walker.nextNode())) {
      textNodes.push(n);
    }

    // 1. Khóa từ ghép & Khóa Số + Đơn vị đo
    textNodes.forEach(t => {
      let val = t.nodeValue;
      if (!val || !val.trim()) return;

      // Khóa từ ghép
      RX_WORDS.forEach(r => {
        val = val.replace(r, (match, pre, word) => pre + word.replace(/\s+/g, NB));
      });

      // Khóa Số + Đơn vị (VD: 32 mmHg, 18 cm, 19 °C, 100 %, 70 %, 1.889.000 ₫, 24 giờ, 7:15 sáng)
      val = val.replace(/(\d+[\d.,]*)\s+(?=[\p{L}%°₫])/gu, '$1' + NB);

      // Khóa gạch nối số / khoảng giá (VD: 40 – 50)
      val = val.replace(/\s+([–—×])\s+/g, NB + '$1' + NB);

      t.nodeValue = val;
    });

    // 2. Chống rớt từ mồ côi ở cuối đoạn (Widow word prevention)
    for (let i = textNodes.length - 1; i >= 0; i--) {
      const textNode = textNodes[i];
      let str = textNode.nodeValue;
      let trimmed = str.replace(/\s+$/, '');
      if (!trimmed) continue;

      const lastSpaceIdx = trimmed.lastIndexOf(' ');
      if (lastSpaceIdx < 0) break;

      const lastWord = trimmed.slice(lastSpaceIdx + 1).replace(/[.,;:!?)]/g, '');
      // Nếu từ cuối đã được khóa với từ trước bằng NB thì không cần can thiệp
      if (lastWord.indexOf(NB) >= 0) break;

      // Dính 2 từ cuối lại bằng khoảng trắng không ngắt
      textNode.nodeValue = trimmed.slice(0, lastSpaceIdx) + NB + trimmed.slice(lastSpaceIdx + 1) + str.slice(trimmed.length);
      break;
    }
  }

  function polishTypography(rootEl) {
    const root = rootEl || document;
    const elements = root.querySelectorAll(TARGET_SELECTOR);
    elements.forEach(polishElement);
  }

  // Khởi chạy khi DOM sẵn sàng
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => polishTypography());
  } else {
    polishTypography();
  }

  // Xuất ra window để gọi lại khi có modal, drawer hoặc AJAX load
  window.dopaPolishTypography = polishTypography;
})();
